import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './calendar.css';
import { ReactComponent as NextIcon } from 'Icons/ProteinFormulation/Next.svg';
import { ReactComponent as BackIcon } from 'Icons/ProteinFormulation/Back.svg';
import { getDateISOFormat } from 'utils/Global';
import { RMModal } from 'components/modal';

type RMDatePickerProps = {
  date: Date;
  onChange: (e) => void;
  className?: string;
  isReadOnly?: boolean;
};

const RMDatePicker = ({
  date,
  onChange,
  className = '',
  isReadOnly = false,
}: RMDatePickerProps) => {
  const [showCalendar, setShowCalendar] = useState<boolean>(false);

  const getTileClassName = (params) => {
    const tempDate = new Date(params.date);
    const today = new Date();
    if (params.view === 'month') {
      if (tempDate.toDateString() === date.toDateString()) {
        return 'selectedTile';
      }
      if (tempDate.getMonth() !== params.activeStartDate.getMonth()) {
        return 'otherMonth';
      }
      if (
        tempDate.toDateString() === today.toDateString() &&
        tempDate.toDateString() !== date.toDateString()
      ) {
        return 'currentDate';
      }
      return 'customTile';
    }
    if (params.view === 'year') {
      return 'monthsTile';
    }
  };
  const getNavLabel = ({ date, view, label }) => {
    return (
      <div
        id={`controls-rmdatepicker-navlabel-${label}`}
        data-testid={`controls-rmdatepicker-navlabel-${label}`}
        className="navLabel"
      >
        {label}
      </div>
    );
  };

  return (
    <>
      <input
        id={`controls-rmdatepicker-input`}
        data-testid={`controls-rmdatepicker-input`}
        className={className || 'inputFieldDetails'}
        type="text"
        value={getDateISOFormat(date)}
        onClick={() => {
          if (!isReadOnly) {
            setShowCalendar(!showCalendar);
          }
        }}
        readOnly={isReadOnly}
      />
      <RMModal
        id={`controls-rmdatepicker-modal-inputdate`}
        data-testid={`controls-rmdatepicker-modal-inputdate`}
        heading="Input Date"
        showModal={showCalendar}
        setShowModal={setShowCalendar}
        onHide={() => {
          setShowCalendar(false);
        }}
        onOk={() => {
          setShowCalendar(false);
        }}
        body={
          <Calendar
            id="controls-rmdatepicker-modal-calendar"
            data-testid="controls-rmdatepicker-modal-calendar"
            value={date}
            onChange={onChange}
            nextLabel={<NextIcon />}
            next2Label={null}
            prevLabel={<BackIcon />}
            prev2Label={null}
            tileClassName={getTileClassName}
            className={['mycalendar']}
            navigationLabel={getNavLabel}
          />
        }
        okButtonText="Ok"
        hideCloseButton={true}
      />
    </>
  );
};
export default RMDatePicker;
